<p-dialog [(visible)]="isVisible"
          [modal]="true"
          [closable]="false"
          [style]="{ width: '25rem' }"
>
  <div class="flex flex-column">
    <div class="text-lg-semibold text-gray-900">
      Potvrda uplate
    </div>
    <div class="mt-1 text-sm-regular text-gray-600">Potvrdite status zahteva da ste primili uplatu.</div>
  </div>
  <ng-template #header>
    <div class="flex align-items-center justify-content-between w-full">
      <div class="flex justify-content-center align-items-center dialog-header-icon">
        <app-check-circle stroke="#414651" width="20px" height="20px"></app-check-circle>
      </div>
      <app-x-close stroke="#ADB0B8" width="12" height="12" class="cursor-pointer" (click)="cancelled.emit()"></app-x-close>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="flex justify-content-end align-items-center w-full">
      <app-button [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.MD" (btnClicked)="cancelled.emit()">
        <div class="text-sm-semibold text-gray-900">Otkaži</div>
      </app-button>
      <app-button class="ml-2-5" [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="confirmed.emit()">
        <div class="text-sm-semibold text-white">Potvrdi</div>
      </app-button>
    </div>
  </ng-template>
</p-dialog>
